var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-layout-content',{staticClass:"content",staticStyle:{"padding":"0 25px"}},[_c('div',{style:({ 
    background: '#fff', 
    padding: '24px', 
    minHeight: '280px',
    borderRadius: '5px',
    boxShadow: 'rgba(0, 0, 0, 0.2) 0px 4px 8px 0px, rgba(0, 0, 0, 0.19) 0px 6px 20px 0px'
  })},[_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }